<template>
  <div class="myRecord-view">
    <nav-menu :navMenuList="navMenuList"
    :activeIndex="activeIndex"
    @handleSelect="handleSelect"></nav-menu>
    <div class="content">
      <div class="content-top">
        <div class="d-time">
          时间:
          <el-date-picker
            size="small"
            v-model="value6"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="d-name">
          <input type="text" placeholder="请输入书名">
          <button><i class="el-icon-search"></i></button>
        </div>
      </div>
      <div class="content-middle">
        <el-card shadow="always" class="myrecord-card">
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center">
            </el-table-column>
            <el-table-column
              prop="name"
              label="图书"
              align="center">
            </el-table-column>
            <el-table-column
              prop="time"
              label="购买时间"
              align="center">
            </el-table-column>
            <el-table-column
              prop="money"
              label="单价"
              align="center">
            </el-table-column>
            <el-table-column
              prop="payType"
              label="付款方式"
              align="center">
            </el-table-column>
          </el-table>
        </el-card>
        <p class="p-money">统计消费2000元</p>
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="100"
            layout="prev, pager, next, jumper"
            :total="1000">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
      currentPage3: 5,
      activeIndex: '0',
      tableData: [{
        id: '1',
        time: '2016-05-03',
        money: '20.22',
        name: '政策研究与聚餐',
        payType: '在线支付'
      }, {
        id: '2',
        time: '2016-05-03',
        money: '20.22',
        name: '政策研究与聚餐',
        payType: '在线支付'
      }, {
        id: '3',
        time: '2016-05-03',
        money: '20.22',
        name: '政策研究与聚餐',
        payType: '在线支付'
      }, {
        id: '4',
        time: '2016-05-03',
        money: '20.22',
        name: '政策研究与聚餐',
        payType: '在线支付'
      }],
      value6: '',
      navMenuList: [{
        text: '我的购书记录',
        pathName: 'MyRecord'
      }]
    }
  },
  methods: {
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    },
    handleSelect (key) {
      this.activeIndex = key
      // console.log(this.navMenuList[key].text)
    }
  }
}
</script>
<style lang="less" scoped>
  .myRecord-view{
    .content{
      height: 500px;
      margin-top: 30px;
      .content-top{
        display: flex;
        .d-time{
          flex: 1;
        }
        .d-name{
          button{
            background-color: #B7151E;
            border: 0;
            outline: none;
            cursor: pointer;
            color: white;
            padding: 0 10px;
            height: 32px;
            font-size: 16px;
            float: right;
            margin-left: 10px;
          }
          input{
            width: 200px;
            outline: none;
            border: 2px solid #B7151E;
            height: 26px;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
          }
        }
      }
      .content-middle{
        margin-top: 20px;
        .p-money{
          text-align: right;
          font-size: 14px;
        }
        .pagination{
          text-align: center;
        }
      }
    }
  }
</style>
<style lang="less">
  .myrecord-card{
    .el-card__body{
      padding: 0 !important;
      table{
        thead{
          tr{
            th{
              background: #E1E1E1;
            }
          }
        }
      }
    }
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #F76B6E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/MyRecord/myrecord.vue


// WEBPACK FOOTER //
// src/components/Personal/MyRecord/myrecord.vue